<template src="./ContactHistory.html"></template>

<script>
export default {
  name: "contact-history",
  props: ["patientId"],
  data() {
    return {
        history: [],
        popupNewContact: false,
        reason: "",
        description: "",
        invalid: {
          reason: false,
          description: false,
        }
    };
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getContactHistory();
    },
    newContact(){
      const vm = this;
      vm.popupNewContact = true;
    },
    goBackToAppointmentHistory(){
      const vm = this;
      vm.$emit("goToAppointmentHistory", event);
    },
    getContactHistory() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$props.patientId +
            "/contacts?page=0&size=50&sort=date,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.history = response.data.content;
          }
        });
    },
    checkFields() {
      const vm = this;
      vm.invalid.reason = vm.reason === "";
      vm.invalid.description = vm.description === "";
      const proceed = vm.invalid.reason || vm.invalid.description;
      if (!proceed) vm.saveContact();
    },
    saveContact() {
      const vm = this;
      const input = {
        title: vm.reason,
        description: vm.description,
      };
      vm.axios.
        post(
          vm.$store.state.filooServer +
          "consultant/patients/" +
          vm.$props.patientId +
          "/contacts",
          input,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          },
        )
        .then(() => {
          vm.popupNewContact = false;
          vm.getContactHistory();
        })
        .catch( () => {
          vm.showNotifyWarning(
            "Não foi possível inserir as informações do contato agora. Por favor, tente novamente mais tarde!", 
            6000
          );
        })
    },
  }
};
</script>
<style src="./ContactHistory.css">
</style>